var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeading(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "font_download_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.035,
    height: 45.035,
    viewBox: "0 0 45.035 45.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    "data-name": "Path 61963",
    d: "M0,0H45.035V45.035H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_x33_4.Heading",
    d: "M42.517,28.076V55.125h2.7a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352H31.7a1.352,1.352,0,0,1-1.352-1.352v-2.7A1.352,1.352,0,0,1,31.7,55.125h2.7V44.306H18.172v10.82h2.7a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352H7.353A1.352,1.352,0,0,1,6,59.183v-2.7a1.352,1.352,0,0,1,1.352-1.352h2.7V28.076h-2.7A1.352,1.352,0,0,1,6,26.723v-2.7a1.352,1.352,0,0,1,1.352-1.352H20.877a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352h-2.7V38.9H34.4V28.076H31.7a1.352,1.352,0,0,1-1.352-1.352v-2.7A1.352,1.352,0,0,1,31.7,22.666H45.222a1.352,1.352,0,0,1,1.352,1.352v2.7a1.352,1.352,0,0,1-1.352,1.352Z",
    transform: "translate(-3.771 -19.083)",
    fill: "#828282"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading);
export default __webpack_public_path__ + "static/media/Heading.a5c0b754a4328ea86aa65b57f4402d61.svg";
export { ForwardRef as ReactComponent };